<template>  
    <div class="card mb-5 mb-xxl-8"  v-if="model">
        <div class="card-body pt-3 pb-0">
            <div class="d-flex flex-wrap flex-sm-nowrap">
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-start flex-wrap mb-0">
                        <div class="d-flex flex-column">
                            <div class="d-flex align-items-center mb-2">
                                <div class="text-white fs-2 fw-bolder me-1">{{  model.turma.descricao   }}</div>
                                <div>
                                    <span class="svg-icon svg-icon-1 svg-icon-primary">
                                        <inline-svg src="media/icons/duotone/Design/Verified.svg" />
                                    </span>
                                </div>
                            </div> 
                            <div class="d-flex flex-wrap fw-bold fs-6 mb-2 pe-2">
                                <div class="d-flex align-items-center text-gray-400 me-5 mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/General/User.svg" />
                                    </span>
                                    {{  model.status.nome }}
                                </div>  
                                <div class="d-flex align-items-center text-gray-400 me-5 mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/Map/Marker1.svg" />
                                    </span>
                                    {{model.pelotao}}º Pelotão
                                </div>
                                <div class="d-flex align-items-center text-gray-400 me-5 mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/Map/Marker1.svg" />
                                    </span>
                                    Matricula {{model.id}}
                                </div>
                                <div class="d-flex align-items-center text-gray-400 mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/Communication/Mail-at.svg" />
                                    </span>
                                    Número {{model.numeroCurso}}{{ model.isRemanescente ? '-R' : '' }}
                                </div>
                                 
                            </div>
                        </div> 
                    </div>  
                </div>
            </div>
            <div class="d-flex overflow-auto h-55px">
                <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap"> 
                    <li class="nav-item"> 
                        <router-link :to="{ name: 'profile_matricula_show_notas' , params: {  id:model.id  } }" class="nav-link text-active-secondary me-6"
                            active-class="active">
                            Avaliações
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'profile_matricula_show_faltas' , params: {  id:model.id  } }"
                            active-class="active">
                            Faltas
                        </router-link>
                    </li>  
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'profile_matricula_show_historico' , params: {  id:model.id  } }"
                            active-class="active">
                            Historico
                        </router-link>
                    </li>    
                    <li class="nav-item" v-if="model.turma.liberadoLotacao === 'True'">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'profile_matricula_show_alocacao' , params: {  id:model.id  } }"
                            active-class="active">
                            Lotações Opções
                        </router-link>
                    </li>  
                    <li class="nav-item" >
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'profile_matricula_show_qts' , params: {  id:model.id  } }"
                            active-class="active">
                            QTS
                        </router-link>
                    </li>  
                    <li class="nav-item" v-if="hasAdmin">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'profile_matricula_show_carteira_estudante' , params: {  id:model.id  } }"
                            active-class="active">
                            Carteira de Estudante
                        </router-link>
                    </li>  
                    <li class="nav-item" v-if="hasAdmin">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'profile_matricula_show_segunda_chamada' , params: {  id:model.id  } }"
                            active-class="active">
                            Segunda Chamada
                        </router-link>
                    </li>  
                    
                     
                </ul>
            </div>
        </div>
    </div>
 
    <router-view :matricula="model" v-if="model" ></router-view>
 
</template>

<script lang="ts">   
    
    import MatriculaService  from '@/service/v10/sigap/MatriculaService'; 
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site';   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "MatriculaShow",
        components: {   },   
    }) 
    export default class MatriculaShow extends Vue {
        
        @authStore.Getter
		public perfis!: any  

        @authStore.Getter
		public token!: any 
  
        public service = new MatriculaService();
        public model: any = null ;
        public processando = false ;
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        get hasAdmin( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin  ] ,  this.perfis); 
        }

        public formatCPF( cpf ): string {
            return SiteUtils.formatCPF( cpf );
        }

        created(){
            this.buscaMatricula(); 
        }

        public statusAlterado(dados){ 
            this.buscaMatricula() ;
        }

        public buscaMatricula(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.model =  JSON.parse(JSON.stringify( response ));  
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public gerarHistoricoExcell() {  
            window.open( this.service.getApiUrl() + '/' + this.$route.params.id + '/boletim/excel' + '?token=' +  this.token );
		}
 
    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    }

    .start-90{
        left: 97% !important;
    }
    
    .col-12{
        margin-bottom: 40px;
    }

    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    }

    .card{
        background-color: #304988 !important;
    }

    .nav-line-tabs .nav-item .nav-link.active, .nav-line-tabs .nav-item.show .nav-link, .nav-line-tabs .nav-item .nav-link:hover:not(.disabled) { 
        border-bottom: 3px solid #E3A11E; 
    }

</style>
